import React, { useEffect, useState } from "react";
import { Container, Row, Col, Spinner, Alert } from "react-bootstrap";
import apiCall from "../components/Api/api";
import parse from 'html-react-parser';

const TermsCondition = () => {
  const [terms, setTerms] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        setLoading(true);
        const response = await apiCall({
          url: `termofuse`,
          method: "GET",
          headers: "",
        });


        if (response?.status === 200) {
          setTerms(response?.data?.content);
        } else {
          throw new Error("Failed to load terms. Please try again.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  return (
    <>
      <section className="banner_section-inner position-relative">
         <picture className="position-relative">
          <source
            srcSet={"/img/t&c_banner.jpg"}
            media="(max-width:576px)"
            type="image/jpg"
          />
          <img
            src="/img/t&c_banner.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
            type="image/jpg"
            loading="lazy"
          />
        </picture>
      </section>

      <section className="terms_wrapper">
        <Container>
          <Row className="pb-5 mb-5 margin_bottomfooter">
            <Col xs={12}>
              <div className="title_terms">
                <h2>Terms of Use</h2>
              </div>
            </Col>
            <Col xs={12}>
              <div className="terms_details">
                <div className="content_terms">
                  {loading && (
                    <div className="text-center py-5">
                      <Spinner
                        animation="border"
                        style={{ color: "#09422d" }}
                      />
                    </div>
                  )}
                  {error && <Alert variant="danger">{error}</Alert>}
                  {!loading && !error && (
                    <div>
                    {terms && parse(terms)}
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TermsCondition;
